import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { process, FIND } from '../services/Api';
import { Bill } from '../redux/reducers/bill';

export const useBill = (
  queries = '',
  sort = '$sort[date]=-1',
  skip = 0,
  limit = 10
) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ limit, queries, sort, skip });
  const dispatch = useDispatch();

  const getBills = useCallback(async () => {
    dispatch(Bill.billRequest());
    setLoading(true);
    let oSendParams = {
      ...params,
    };
    if (oSendParams.sort) {
      if (oSendParams.queries) {
        oSendParams.queries += `&${oSendParams.sort}`;
      } else {
        oSendParams.queries = oSendParams.sort;
      }
    }
    const oResponse = await process(FIND, 'bills', {}, oSendParams);

    setLoading(false);
    if (oResponse.ok) {
      dispatch(Bill.billFetched(oResponse.data));
      setData(oResponse.data);
    } else {
      dispatch(Bill.billFailure(oResponse.data));
    }
  }, [dispatch, process, params]);

  useEffect(() => {
    getBills();
  }, [getBills]);

  const onChangeParams = (q = '', st = '', s = 0, l = 10) => {
    setParams({ limit: l, queries: q, sort: st, skip: s });
  };

  const update = () => getBills();

  return [{ ...params, ...data }, loading, onChangeParams, update];
};
